import { render } from "./DocumentationSection.vue?vue&type=template&id=44ebb0c8&scoped=true"
import script from "./DocumentationSection.vue?vue&type=script&lang=js"
export * from "./DocumentationSection.vue?vue&type=script&lang=js"

import "./DocumentationSection.vue?vue&type=style&index=0&id=44ebb0c8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ebb0c8"]])

export default __exports__